import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

/* eslint-disable */

/**
 * @global dataLayer can be filled info and send to Google Tag Manager.
*/
window.dataLayer = window.dataLayer || [];
/**
 * @function pushEvent - Sendout data ,needs three params:
 * @param {string} eventAction
 * @param {string} eventCategory
 * @param {string} eventLabel
 */

var pushEvent = function pushEvent(eventAction, eventCategory, eventLabel) {
  window.dataLayer.push({
    event: "GAEvent",
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel: eventLabel
  });
};
/**
 * At first listen page, second get variable buried`s value,then sendout data
 * @variable {string} buried - comes from the clicked html tag.
 * @param {Array} buriedValArr - at least 3 params
 * Usage: set property at html tags. <div data-buried="'action','category','label'"></div>
 */


export var addGtmListener = function addGtmListener() {
  document.addEventListener("click", function (e) {
    var buried = e.target.dataset.buried;
    if (!buried) return;
    var buriedArr = buried.split(",");
    pushEvent.apply(void 0, _toConsumableArray(buriedArr));
  }, true);
};
/**
 * Export event to use it in the method.
 * Usage:  pushEvent('action','category','label')
 */

export default pushEvent;